import { BehaviorSubject, Observable } from "rxjs";
import { SideMenuTabComponent } from "../side-menu-tab.component";

export class SideMenuTabService {
  private _selectedTab$: BehaviorSubject<SideMenuTabComponent | undefined> = new BehaviorSubject<SideMenuTabComponent | undefined>(undefined);

  public selectedTab$: Observable<SideMenuTabComponent | undefined> = this._selectedTab$.asObservable();

  private _isInitialTabSet: boolean = false;

  public onTabSelected (tab: SideMenuTabComponent): void {
    const selectedTab: SideMenuTabComponent | undefined = this._selectedTab$.getValue();

    if (selectedTab)
      selectedTab.isSelected.set(false);

    this._selectedTab$.next(tab);
    tab.isSelected.set(true);
  }

  public registerTab (tab: SideMenuTabComponent): void {
    if (tab.isSelected()) {
      if (this._isInitialTabSet)
        tab.isSelected.set(false);
      else {
        this.onTabSelected(tab);
        this._isInitialTabSet = true;
      }
    }
  }
}
